/**
 * Menu - animacja rozwinięcia
 * -  pokazanie podsawowej naimacji (menu) po kliknieciu hamburgermenu
 */

export function initMenu() {
  const hamburger = document.querySelector('.hamburger');
  const menu = document.querySelector('.menu');
  if (!hamburger || !menu) return;

  const links = menu.querySelectorAll('a');

  hamburger.addEventListener('click', () => {
    const isOpen = menu.classList.contains('show');

    if (!isOpen) {
      // 🔹 Przy otwieraniu — reset do pozycji startowej
      links.forEach(link => {
        link.style.transition = 'none';
        link.style.transform = 'translateX(20px)';
        link.style.opacity = '0';
      });

      // 🔹 Wymuszenie odświeżenia (reset animacji)
      void menu.offsetWidth;

      // 🔹 Pokazujemy menu i odpalamy animację
      menu.classList.add('show');
      links.forEach((link, i) => {
        link.style.transition = '';
        link.style.transitionDelay = `${i * 0.13}s`;
        link.style.transform = 'translateY(0)';
        link.style.opacity = '1';
      });

    } else {
      // 🔹 Zamykamy z odwrotną animacją sprężyny
      links.forEach((link, i) => {
        link.style.transitionDelay = `${i * 0.13}s`;
        link.style.transform = 'translateX(20px)';
        link.style.opacity = '0';
      });

      // 🔹 Usuwamy klasę po zakończeniu animacji
      setTimeout(() => {
        menu.classList.remove('show');
      }, 800);
    }
  });
}




/**
 * Menu - zmiana koloru menu dla sekcji `.black`
 * - dodaje klasę .dark do body, gdy czarna sekcja jest w widoku
 * - co umożliwia kontrolę wyglądu przy pomocy styli CSS
 */
export function initMenuBlackSection() {
  const blackSections = document.querySelectorAll('.section.black');
  if (blackSections.length === 0) return;

  const observer = new IntersectionObserver(() => {
    const anyVisible = Array.from(blackSections).some(sec => {
      const rect = sec.getBoundingClientRect();
      return rect.top < window.innerHeight * 0.6 && rect.bottom > window.innerHeight * 0.4;
    });

    document.body.classList.toggle('dark', anyVisible);
  }, { threshold: 0.4 });

  blackSections.forEach(section => observer.observe(section));
}